import { useState, useMemo } from 'react';
import { notificationError } from '../../../../../../../components/Notifications/callNotifcation';
import { ITemplateGroupTag } from '../../../../../../../entities/template/private-template-tag-group/model/types/types';
import { useCreateModuleTag } from '../../../../../../../features/module/tag/create/api';
import { privateTemplateModuleTagGroupAPI } from '../../../../../../../entities/template/private-template-tag-group/template-tag-group/api/privateTemplateModuleTagGroupAPI';
import { TagGroupType } from '../../../../../../../entities/template/private-template-tag-group/model/types';

export const usePrivateModuleTags = (
	groupId: string | undefined,
	tagsData: any,
	tagsWithoutGroups: ITemplateGroupTag[] | undefined,
	search: string,
) => {
	const [tagName, setTagName] = useState('');
	const { onCreateTag } = useCreateModuleTag();
	const [bindTag] = privateTemplateModuleTagGroupAPI.useBindMutation();

	let tags: ITemplateGroupTag[] = [];
	if (groupId && tagsData?.tagGroups) {
		const group = tagsData.tagGroups.find((g: any) => g.id === groupId);
		if (group) {
			tags = group.tags;
		}
	}

	const allTags = groupId === TagGroupType.tagsWithoutGroup ? tagsWithoutGroups || [] : tags;

	const filteredTags = useMemo(() => {
		if (!allTags || !allTags.length) {
			return [];
		}

		return allTags.filter(
			tag => tag && tag.name && tag.name.toLowerCase().startsWith(search.toLowerCase()),
		);
	}, [allTags, search]);

	const onTagNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTagName(event.target.value);
	};

	const validateTagName = (name: string) => {
		if (name.length < 2) {
			notificationError('Тег должен содержать не менее 2-х символов');
			return false;
		}
		return true;
	};

	const bindCreatedTag = async (name: string) => {
		if (validateTagName(name)) {
			try {
				const res = await onCreateTag(name);
				if (res && groupId && groupId !== TagGroupType.tagsWithoutGroup) {
					await bindTag({ groupId, tags: [res.id] });
				}
				setTagName('');
			} catch (error) {
				notificationError('Ошибка при создании тега');
			}
		}
	};

	const handleCreateTag = async () => {
		await bindCreatedTag(tagName);
	};

	return {
		tagName,
		setTagName,
		filteredTags,
		onTagNameChange,
		handleCreateTag,
		bindCreatedTag,
		allTags,
	};
};
